export default "__VITE_ASSET__DjPJRX3O__"